import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { NotificationsPage } from "@/features/notifications/routes/Notifications";

export const Route = createLazyFileRoute("/_auth/_app/help/notifications")({
  component: memo(NotificationsPage),
});
